import { render, staticRenderFns } from "./MsupplierUpdate.vue?vue&type=template&id=08ec5113"
import script from "./MsupplierUpdate.vue?vue&type=script&lang=js"
export * from "./MsupplierUpdate.vue?vue&type=script&lang=js"
import style0 from "./MsupplierUpdate.vue?vue&type=style&index=0&id=08ec5113&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports